<template>
    <div>
        <div class="margin-top-10 margin-left-15" v-if="alltype!='query'">
            <vButton theme="primary" class="margin-right-10" @click="additem">{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
            <vButton theme="success" @click="exportExcel">{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>
        </div>
        <vTable
            class="margin-15 producttable"
            :columns="columns"
            :data="formList"
            size="small"
            ref="tablequery"
            border
        ></vTable>
        <vModal
            class="hidefooter customerupload"
			v-model="operate.show"
			:title="operate.title"
			v-bind="operate"
            >

            <compUpload v-bind="getFileProps" @on-close="upclose" @on-success="upsuccess" ></compUpload>
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>

<script>
import { HttpVsSkuList } from '@/service/boss/allot';
import { HttpGetAvailQuantity } from "@/service/boss/b2border";

export default {
    props:['productdata','alltype','warehouseid'],
    components: {
		compUpload: () => import("@components/templates/upload"),
	},
    data(){
        return {
            formList:[],
            operate:{
                show:false,
                title:'',
            },
            erpSkusList:[],
            flag:1,
        }
    },
    watch:{
        productdata:{
            deep:true,
            handler(val){
                if(this.flag == 1){
                    // 赋值
                    if(this.alltype != 'query'){
                        val.map((item,index)=>{
                            // this.$set(this.formList,index,val[index])
                            // 第一次请求获取erpsku的下拉
                            item.$Edit = true
                            this.getErpskuList(item.erpSku,index)
                        })
                        this.formList = val
                    }else{
                        this.formList = val
                    }
                    // 请求可用库存
                    this.getFormAvailQuantit(val)
                    this.flag = 2
                    // console.log(this.formList)
                }
            }
        },
    },
    computed:{
        columns() {
            const _this = this
            let arrlist = [
                {
                    key: 'erpSku',
                    renderHeader:(h,params)=>{
                        if(this.alltype == 'query'){
                            return h('div',[
                                h('strong','ERPSKU')
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong','ERPSKU')
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Select',{
                                    props:{
                                        transfer:true,
                                        filterable:true,
                                        clearable:true,
                                        value:row.erpSku,
                                        placeholder:this.$t('erp.b2border.erpsku_tip',{defaultValue:'请输入erpsku'})
                                    },
                                    on: {
                                        'on-query-change':(val)=>{
                                            // console.log(val)
                                            _this.remoteMethod(val,index)
                                        },
                                        'on-change':(val)=>{
                                            _this.changeErpsku(val,index)

                                        }
                                    },
                                },
                                (_this.erpSkusList[index] || []).map((item)=>{
                                    return h('Option', {
                                        props: {
                                            value: item.name,
                                            label: item.name
                                        }
                                    });
                                })

                            )

                        }else{
                            return <div>
                            {row.erpSku}
                            </div>
                        }
                    }
                }, {
                    title: this.$t('erp.b2border.usestock',{defaultValue:'可用库存'}),
                    key: 'userable',
                    render(h, { row,index }) {
                        return <div>{row.userable}</div>
                    }
                }, {
                    key: 'qty',
                    renderHeader:(h,params)=>{
                        if(this.alltype == 'query'){
                            return h('div',[
                                h('strong',this.$t('global.common.quantity',{defaultValue:'数量'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t('global.common.quantity',{defaultValue:'数量'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.qty
                                },
                                on: {
                                    'input':(event) => {
                                        row.qty = event
                                        _this.formList[index] = row

                                        let num;
                                        if(_this.formList[index].unitPrice){
                                            num = _this.formList[index].unitPrice*event
                                        }
                                        // console.log(_this.formList[index].fobPrice,num)
                                        _this.formList[index].amount = num.toFixed(4)
                                        _this.computedCost(_this.formList)
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.qty}
                            </div>
                        }
                    }
                }, {
                    key: 'unitPrice',
                    renderHeader:(h,params)=>{
                        if(this.alltype == 'query'){
                            return h('div',[
                                h('strong',this.$t('global.common.unit_price',{defaultValue:'单价'}))
                            ])
                        }else{
                            return h('div',[
                                h('Icon',{
                                    props:{
                                        type:"ios-medical",
                                        color:"#ed3f14"
                                    },
                                }),
                                h('strong',this.$t('global.common.unit_price',{defaultValue:'单价'}))
                            ])
                        }
                    },
                    render(h, { row,index }) {
                        if(row.$Edit){
                            return h('Input',{
                                props: {
                                    size:'small',
                                    value:row.unitPrice
                                },
                                on: {
                                    'input':(event) => {
                                        row.unitPrice = event
                                        _this.formList[index] = row

                                        let num;
                                        if(_this.formList[index].qty){
                                            num = _this.formList[index].qty*event
                                        }
                                        // console.log(_this.formList[index].fobPrice,num)
                                        _this.formList[index].amount = num.toFixed(4)
                                        _this.computedCost(_this.formList)
                                    }
                                },
                            })
                        }else{
                            return <div>
                            {row.unitPrice}
                            </div>
                        }
                    }
                }, {
                    title: this.$t('erp.b2c.money',{defaultValue:'金额'}),
                    key: 'amount',
                    render(h, { row,index }) {
                        return <div>{row.amount}</div>
                    }
                },{
                    title: this.$t('global.common.operation',{defaultValue:'操作'}),
                    width:140,
                    render(h, { row, index }) {
                        return h('div',[
                            h('Button', {
                                props:{
                                    // class:'middle-content',
                                    size:'small',
                                    disabled:_this.alltype == 'query'
                                },
                                on: {
                                    click: () => {
                                        _this.comremove(index)
                                    }
                                }
                            },this.$t('global.common.delete',{defaultValue:'删除'}))
                        ])
                    }
                },
            ]
            if(this.alltype == 'query'){
                arrlist.splice(1,1)
                arrlist.splice(4,1)
                let data = {
                    title: this.$t('erp.b2border.delivery_status',{defaultValue:'发货状态'}),
                    key: 'shippingStatus',
                    render(h, { row,index }) {
                        switch(row.shippingStatus){
                            case 0:return this.$t('erp.b2c.orderstatus_unshipped',{defaultValue:'未发货'});break;
                            case 1:return this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'});break;
                        }
                    }
                }
                arrlist.splice(4,1,data)
                return arrlist
            }else{
                return arrlist
            }
        },
        getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_BOSS + '/api/v2/B2bOrder/import',
				name: "excelFile",
                download:()=>{
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/B2bOrder/template', {}, 'download')
                }
			}
		},
    },
    methods:{
        getFormAvailQuantit(arrdata){
            // console.log(arrdata)
            let arr = arrdata.map(item=>{
                return {erpsku:item.erpSku}
            })
            // console.log(arr,'arr')
            HttpGetAvailQuantity({
                orgId:global.SYSID,
                orgWarehouseId:this.warehouseid,
                stockGroupInventoryitems:arr,
            }).then(res=>{
                // console.log(res.data)
                this.formList.map((item,index)=>{
                    this.$set(this.formList[index],'userable',res.data.erpMap[index].quantity)
                    // this.formList[index].userable = res.data.erpMap[index].quantity
                })
                // console.log(this.formList)
                // this.formList[index].userable = res.data.erpMap[0].quantity
            },err=>{

            })
        },
        getErpskuList(query,index,type){
            let data = {};
            if(type=='export'){
                data = {page: 1,rows: 100,'search[EQ_erpSku]':query}
            }else{
                data = {page: 1,rows: 100,'search[CN_erpSku]':query}
            }
            if(query){
                HttpVsSkuList(data).then(res => {
                    let itemsku = res.data.content[0];
                    // this.erpSkusList[index].push(itemsku)
                    this.$set(this.erpSkusList,index,[{ name: itemsku.erpSku, id: itemsku.id, title:itemsku.nameEn }])
                    // console.log(this.erpSkusList,'45454545')
                });
            }
        },
        remoteMethod(query,index){
            // console.log(343434343434)
            if(query){
                HttpVsSkuList({page: 1,rows: 100,'search[CN_erpSku]':query}).then(res => {
                    let arrlist = res.data.content.map((item) => {
                        return { name: item.erpSku, id: item.id, title:item.nameEn }
                    });
                    this.$set(this.erpSkusList,index,arrlist)
                });
                // console.log(this.erpSkusList)
            }
        },
        changeErpsku(val,index){
            this.formList[index].erpSku = val
            if(val){
                this.GetAvailQuantity(val,index)
            }
        },
        GetAvailQuantity(val,index){
            let data = {
                erpsku:val
            }
            let arr =[]
            arr.push(data)
            HttpGetAvailQuantity({
                orgId:global.SYSID,
                orgWarehouseId:this.warehouseid,
                stockGroupInventoryitems:arr,
            }).then(res=>{
                // console.log(res.data)
                this.formList[index].userable = res.data.erpMap[0].quantity
            },err=>{

            })
        },
        additem(){
            let data = {
                $Edit: true,
                userable:0,
                erpSku:'',
                qty:0,
                unitPrice:0,
                amount:0,
            }
            this.formList.push(data)
        },
        comremove(index){
            this.formList.splice(index, 1);
        },
        exportExcel(){
            this.operate.show = true
            this.operate.title = this.$t('erp.b2c.import_data',{defaultValue:'导入数据'})
        },
        // 计算总金额的方法
        computedCost(datalist){
            this.$emit('on-listcost',datalist)
        },
        upclose(){
            this.operate.show = false
        },
        upsuccess(resData){
            resData.data.map(item=>{
                item.$Edit = true
            })
            this.formList = this.formList.concat(resData.data);
            this.formList.map((item,index)=>{
                this.getErpskuList(item.erpSku,index,'export')
                this.formList[index].amount = this.formList[index].qty*this.formList[index].unitPrice
            })
            // console.log(this.formList)
            this.getFormAvailQuantit(this.formList)
            this.computedCost(this.formList)
            this.operate.show = false
        }
    }
}
</script>
